<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import PageAlerts from "@/components/page-alerts";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Balance Sheet",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    PageAlerts,
  },
  data() {
    return {
      title: "Balance Sheet",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Balance Sheet",
          active: true,
        },
      ],
      data: {
        year: "",
        month: "",
        type: "balancesheet",
      },
    };
  },
  computed: {
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("accounts", ["getBalancesheet", "SaveStatus"]),
  },
  watch: {
    // getSuccessConfirm(newValue) {
    //   if (newValue == true) {
    //   }
    // },
  },
  methods: {
    ...mapActions({
      FetchBalancesheet: "accounts/fetchBalancesheet",
      PrintBalanceSheetDoc: "accounts/printBalanceSheetDoc",
      FetchYears: "marks/fetchYear",
    }),
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        const new_m = m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return m < 0 ? `-${new_m}` : new_m;
      } else {
        return m;
      }
    },
    fetchBalanceSheetDoc() {
      this.getBalancesheet.year = this.data.year;
      this.PrintBalanceSheetDoc(this.getBalancesheet);
    },
    fetchbalancesht() {
      this.FetchBalancesheet(this.data);
    },
    getCurrentYear() {
      const currentDate = new Date();
      this.data.year = currentDate.getFullYear();
      this.data.month = currentDate.getMonth();
      this.FetchBalancesheet(this.data);
    },
  },
  created() {
    this.FetchYears();
    this.getCurrentYear();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('setting_sms')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="form-group col-md-12 row">
              <div class="form-group col-md-2">
                <label for="">Year <small class="text-danger">*</small></label>
                <select
                  class="form-control form-control-sm"
                  required
                  v-model="data.year"
                  @change="fetchbalancesht()"
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
              <div class="col-md-10">
                <b-button-group class="mb-2 float-end">
                  <button
                    v-if="SaveStatus"
                    disabled
                    class="btn btn-sm btn-secondary"
                  >
                    <b-spinner
                      variant="white"
                      small
                      label="Retrieving..."
                    ></b-spinner>
                    Retrieving...
                  </button>
                  <button
                    v-else
                    @click="fetchBalanceSheetDoc()"
                    class="btn btn-sm btn-secondary"
                  >
                    <i class="fa fa-print"></i>
                    Print PDF
                  </button>
                </b-button-group>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <b-tabs content-class="p-3 text-muted">
                <b-tab active class="border-0">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">
                      <i class="fa fa-circle" aria-hidden="true"></i>
                      <b> Overall {{ data.year }}</b></span
                    >
                  </template>
                  <div class="row mt-1">
                    <div class="col-md-12">
                      <strong class="card-title-desc"
                        >Balance Sheet of {{ data.year }}</strong
                      >
                      <div role="tablist" v-if="getBalancesheet">
                        <b-card class="mb-1 shadow-none">
                          <b-card-body
                            role="tab"
                            class="row"
                            v-if="getBalancesheet"
                          >
                            <!-- Schools Assets  -->
                            <div class="col-md-8 row d-flex">
                              <div
                                class="col-md-11 mx-auto"
                                style="
                                    border-bottom: 1px solid rgb(189 190 195);
                                  "
                              >
                                <strong
                                  style="
                                      font-size: 15px;
                                      font-weight: 500;
                                      color: black;
                                    "
                                  >ASSETS</strong
                                >
                              </div>
                              <div>
                                <div
                                  v-for="(assetSections,
                                  index) in getBalancesheet.assets_accounts"
                                  :key="index"
                                  class="col-md-11 mt-3 mx-auto"
                                >
                                  <span>{{ assetSections.parent_name }}</span>
                                  <h6 class="float-end">
                                    {{
                                      thousandSeperater(
                                        assetSections.total_amount
                                      )
                                    }}
                                  </h6>
                                </div>
                              </div>

                              <div class="col-md-11 my-4 mx-auto">
                                <strong
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  TOTAL ASSETS:
                                </strong>
                                <strong
                                  class="float-end"
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  <u>
                                    {{
                                      thousandSeperater(
                                        getBalancesheet.asset_totals
                                      )
                                    }}
                                    UGX
                                  </u>
                                </strong>
                              </div>
                            </div>

                            <!-- Schools Liabilities and Equity -->
                            <div class="col-md-8 row">
                              <div
                                class="col-md-11 mx-auto"
                                style="
                                    border-bottom: 1px solid rgb(189 190 195);
                                  "
                              >
                                <strong
                                  style="
                                      font-size: 15px;
                                      font-weight: 500;
                                      color: black;
                                    "
                                >
                                  LIABILITIES
                                </strong>
                              </div>
                              <div>
                                <div
                                  v-for="(liabilitiesSections,
                                  index) in getBalancesheet.liability_accounts"
                                  :key="index"
                                  class="col-md-11 mt-3 mx-auto"
                                >
                                  <span>{{
                                    liabilitiesSections.parent_name
                                  }}</span>
                                  <h6 class="float-end">
                                    {{
                                      thousandSeperater(
                                        liabilitiesSections.total_amount
                                      )
                                    }}
                                  </h6>
                                </div>
                              </div>

                              <div class="col-md-11 my-4 mx-auto">
                                <strong
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  TOTAL LIABILITIES:
                                </strong>
                                <strong
                                  class="float-end"
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  {{
                                    thousandSeperater(
                                      getBalancesheet.liability_totals
                                    )
                                  }}
                                  UGX
                                </strong>
                              </div>

                              <!-- Owners Equity -->
                              <div
                                class="col-md-11 mx-auto"
                                style="
                                    border-bottom: 1px solid rgb(189 190 195);
                                  "
                              >
                                <strong
                                  style="
                                      font-size: 15px;
                                      font-weight: 500;
                                      color: black;
                                    "
                                  >Equity
                                </strong>
                              </div>
                              <div>
                                <div
                                  v-for="(equitySections,
                                  index) in getBalancesheet.equity_accounts"
                                  :key="index"
                                  class="col-md-11 mt-3 mx-auto"
                                >
                                  <span>{{ equitySections.parent_name }}</span>
                                  <h6 class="float-end">
                                    {{
                                      thousandSeperater(
                                        equitySections.total_amount
                                      )
                                    }}
                                  </h6>
                                </div>
                              </div>

                              <div class="col-md-11 my-4 mx-auto">
                                <strong
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  TOTAL EQUITY:
                                </strong>
                                <strong
                                  class="float-end"
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  {{
                                    thousandSeperater(
                                      getBalancesheet.equity_totals
                                    )
                                  }}
                                  UGX
                                </strong>
                              </div>

                              <div class="col-md-11 mt-2 mx-auto">
                                <strong
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  TOTAL LIABILITIES AND EQUITY:
                                </strong>
                                <strong
                                  class="float-end"
                                  style="
                                      font-size: 13px;
                                      font-weight: 600;
                                      color: black;
                                    "
                                >
                                  <u>
                                    {{
                                      thousandSeperater(
                                        getBalancesheet.liability_totals +
                                          getBalancesheet.equity_totals
                                      )
                                    }}
                                    UGX
                                  </u>
                                </strong>
                              </div>
                            </div>
                          </b-card-body>
                          <b-card-body role="tab" class="row" v-else>
                            <div class="col-md-8 row">
                              <h5 class="text-muted">
                                No information found
                              </h5>
                              <span>
                                There is a possibility that no transactions
                                where made in the necessary accounts for this
                                report. If this insists, Please call for support
                              </span>
                            </div>
                          </b-card-body>
                        </b-card>
                      </div>

                      <PageAlerts
                        v-else-if="SaveStatus == true"
                        title="Please wait"
                        primaryMsg="Loading balance sheet data..."
                        alertType="default"
                      />
                      <PageAlerts
                        v-else
                        title="No data found"
                        primaryMsg="No transactions found for Balance sheet."
                        alertType="default"
                      />
                    </div>
                  </div>
                </b-tab>

                <!-- other tables to be here  -->
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
